export enum SocialType {
  Email = "email",
  Facebook = "facebook",
  Google = "google",
}
